// extracted by mini-css-extract-plugin
export default {"wrapper":"Pagination_wrapper__ZyClm"};